import CSGO from './CSGO';

export default CSGO
